import { useQuery } from '@tanstack/react-query';

import { assetKeys } from '@/shared/lib/query/queryKeys';

import { fetchServiceContainers } from '@/features/asset-detail/api/containersApi';
import type { ContainersResponse, FetchContainersOptions } from '@/features/asset-detail/api/containersApi';

export const useServiceContainers = (
  serviceName: string,
  options: FetchContainersOptions = {},
  enabled: boolean = true
) => {
  return useQuery<ContainersResponse | null>({
    queryKey: assetKeys.serviceContainers(serviceName, options.includeDeleted ?? false),
    queryFn: async () => {
      if (!enabled) {
        return null;
      }
      return fetchServiceContainers(serviceName, options);
    },
    enabled: enabled && !!serviceName,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
